module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Dismiss":"Verwerfen"}}')
  delete Component.options._Ctor
}
